// Analytics event tracking using PostHog
import { trackEvent } from '@/lib/analytics/posthog';
import { hasConsent } from '@/lib/analytics/posthog';

export const event = ({ eventName, category, label, value }: {
  eventName: string,
  category: string;
  label?: string;
  value?: number;
}) => {
  // Only track events if user has given consent
  if (!hasConsent()) {
    return;
  }

  // Track event in PostHog
  trackEvent(eventName, {
    category,
    label,
    value,
  });
};
